import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from '@/lib/auth'

/**
 * Route gate. While auth is bootstrapping we render nothing (avoids
 * flashing the sign-in page for a signed-in user). Once loading completes,
 * unauthenticated users get redirected to /sign-in with the original path
 * captured so we can bounce back after sign-in.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth()
  const location = useLocation()

  if (loading) return null
  if (!session) {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname + location.search }} />
  }
  return <>{children}</>
}
